// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1lTTU","inputWrap":"Table_inputWrap__iIS80","col":"Table_col__3I5k2","bmiTooltip":"Table_bmiTooltip__unG6i"};